<template>
  <div class="polz">
    <header class="header" :class="{ scrolled }">
      <div class="container nav">
        <a class="brand" :href="RAIZ" aria-label="Ir al inicio de Polz Asociados">
          <b>P<span>O</span>LZ</b><small>Gestión y desarrollo inmobiliario</small>
        </a>
        <button
          type="button"
          class="mobile-toggle"
          :aria-expanded="String(menuAbierto)"
          aria-label="Abrir menú"
          @click="menuAbierto = !menuAbierto"
        >
          {{ menuAbierto ? '✕' : '☰' }}
        </button>
        <nav class="nav-links" :class="{ open: menuAbierto }" aria-label="Navegación principal" @click="cerrarMenu">
          <a :href="RAIZ" :aria-current="vista === 'inicio' ? 'page' : null">Inicio</a>
          <a :href="URL_PROYECTOS" :aria-current="vista === 'inicio' ? null : 'page'">Desarrollo</a>
          <a :href="`${RAIZ}#planificacion`">Planificación urbana</a>
          <div class="nav-menu">
            <button type="button" aria-label="Ver consultorías">Consultoría ▾</button>
            <div class="drop">
              <a v-for="(c, clave) in CONSULTORIA" :key="clave" :href="`${RAIZ}#consultoria-${clave}`">{{ c.menu }}</a>
            </div>
          </div>
          <a :href="`${RAIZ}#nosotros`">Nosotros</a>
          <a v-if="vista === 'inicio'" class="nav-contact" href="#contacto">Contacto</a>
          <a v-else class="nav-contact" :href="correo()">Contacto ↗</a>
        </nav>
      </div>
    </header>

    <main>
      <pz-inicio v-if="vista === 'inicio'" />
      <pz-proyectos v-else-if="vista === 'proyectos'" />
      <pz-ficha v-else :proyecto="proyecto" />
    </main>

    <footer v-if="vista === 'inicio'" class="footer footer--simple">
      <div class="container footer-in">
        <div>© {{ anio }} Polz Asociados · Gestión y desarrollo inmobiliario.</div>
        <div>Conocimiento del territorio. Experiencia inmobiliaria. Decisiones estratégicas.</div>
      </div>
    </footer>
    <footer v-else class="footer">
      <div class="container footer-in">
        <a class="brand" :href="RAIZ"><b>P<span>O</span>LZ</b><small>Gestión y desarrollo inmobiliario</small></a>
        <p>{{ DIRECCION }}<br>{{ TELEFONO }} · {{ CORREO }}</p>
        <div class="footer-links">
          <a :href="URL_PROYECTOS">Desarrollo</a>
          <a v-if="vista === 'proyectos'" :href="urlFicha('lomas-de-lambert')">Lomas de Lambert</a>
          <a :href="`${RAIZ}#nosotros`">Nosotros</a>
          <a v-if="vista === 'ficha'" :href="correo()">Contacto</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import './polz.css';
import PzFicha from './PzFicha.vue';
import PzInicio from './PzInicio.vue';
import PzProyectos from './PzProyectos.vue';
import { CONSULTORIA } from './consultoria';
import { CORREO, DIRECCION, RAIZ, TELEFONO, URL_PROYECTOS, correo, urlFicha } from './datos';

export default {
  name: 'LandingPolz',
  components: { PzFicha, PzInicio, PzProyectos },
  props: {
    vista: { type: String, default: 'inicio' },
    proyecto: { type: String, default: '' },
  },
  data() {
    return {
      CONSULTORIA, CORREO, DIRECCION, RAIZ, TELEFONO, URL_PROYECTOS,
      anio: new Date().getFullYear(),
      menuAbierto: false,
      scrolled: false,
    };
  },
  mounted() {
    // El fondo oscuro del tablero queda en body: acá la página es clara.
    document.body.classList.add('polz-body');
    window.addEventListener('scroll', this.alDesplazar, { passive: true });
    this.alDesplazar();
  },
  unmounted() {
    window.removeEventListener('scroll', this.alDesplazar);
  },
  methods: {
    correo,
    urlFicha,
    alDesplazar() {
      this.scrolled = window.scrollY > 40;
    },
    cerrarMenu(evento) {
      if (evento.target.closest('a')) this.menuAbierto = false;
    },
  },
};
</script>
